import DashboardAdmin from './DashboardAdmin.jsx';
import ClientesList from './clientes/ClientesList.jsx';
import ClienteForm from './clientes/ClienteForm.jsx';
import VehiculosList from './vehiculos/VehiculosList.jsx';
import AltaVehiculoWrapper from './vehiculos/AltaVehiculoWrapper.jsx';

export const adminRoutes = [
  { path: '/admin', component: DashboardAdmin },
  { path: '/admin/clientes', component: ClientesList },
  { path: '/admin/clientes/nuevo', component: ClienteForm },
  { path: '/admin/clientes/:id', component: ClienteForm },
  { path: '/admin/vehiculos', component: VehiculosList },
  { path: '/admin/vehiculos/nuevo', component: AltaVehiculoWrapper },
];
